import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import { setReCertification } from "../../redux/slices/FeeSlice";

const RAForm = () => {
  const dispatch = useDispatch();
  const selectedReCer = useSelector((state) => state.Fee.ReCertification);

  const [ReCer, setReCer] = useState({
    administrationFee: "",
    totalContractFee: "",
    surveillanceAudit: [
      {
        surveillanceAuditNumber: 1,
        manDay: {
          onSite: "",
          offSite: "",
          fee: "",
          totalManDays: "",
        },
        totalFee: "",
      },
      {
        surveillanceAuditNumber: 2,
        manDay: {
          year: 2,
          onSite: "",
          offSite: "",
          fee: "",
          totalManDays: "",
        },
        totalFee: "",
      },
      {
        surveillanceAuditNumber: 3,
        manDay: {
          year: 3,
          onSite: "",
          offSite: "",
          fee: "",
          totalManDays: "",
        },
        totalFee: "",
      },
    ],
    re_Certification: [
      {
        manDay: {
          year: 1,
          onSite: "",
          offSite: "",
          fee: "",
          totalManDays: "",
        },
      },
    ],
    auditTypeStates: [
      {
        year: 1,
        name: "Re-Certification",
      },
    ],
  });

  useEffect(() => {
    if (selectedReCer) {
      setReCer(selectedReCer);
    }
  }, [selectedReCer]);

  const calculateTotalManDays = (onSite, offSite) => {
    return (parseFloat(onSite) || 0) + (parseFloat(offSite) || 0);
  };

  const handleChange = (field, value, type, auditNumber = null) => {
    setReCer((prevState) => {
      // Deep copy to ensure immutability
      let updatedState = JSON.parse(JSON.stringify(prevState));

      // Update fields based on type
      if (type === "administrationFee" || type === "totalContractFee") {
        updatedState[type] = value;
      } else if (type === "re_Certification") {
        updatedState.re_Certification[0].manDay[field] = value;
        if (field === "onSite" || field === "offSite") {
          updatedState.re_Certification[0].manDay.totalManDays =
            calculateTotalManDays(
              updatedState.re_Certification[0].manDay.onSite,
              updatedState.re_Certification[0].manDay.offSite
            ).toString();
        }
      } else if (type === "surveillanceAudit") {
        updatedState.surveillanceAudit = updatedState.surveillanceAudit.map(
          (audit) => {
            if (audit.surveillanceAuditNumber === auditNumber) {
              audit.manDay[field] = value;
              if (field === "onSite" || field === "offSite") {
                audit.manDay.totalManDays = calculateTotalManDays(
                  audit.manDay.onSite,
                  audit.manDay.offSite
                ).toString();
              }
            }
            return audit;
          }
        );
      }

      // Calculate total fees
      const administrationFee = parseFloat(updatedState.administrationFee) || 0;
      const reCertificationFee =
        parseFloat(updatedState.re_Certification[0].manDay.fee) || 0;

      // Calculate surveillanceAudit[0].totalFee
      updatedState.surveillanceAudit[0].totalFee =
        administrationFee + reCertificationFee;

      // Update totalFee for other surveillance audits
      updatedState.surveillanceAudit = updatedState.surveillanceAudit.map(
        (audit) => {
          if (audit.surveillanceAuditNumber !== 1) {
            audit.totalFee = parseFloat(audit.manDay.fee) || 0;
          }
          return audit;
        }
      );

      // Calculate totalContractFee
      updatedState.totalContractFee = updatedState.surveillanceAudit.reduce(
        (total, audit) => total + parseFloat(audit.totalFee || 0),
        0
      );

      // Dispatch the updated state to Redux
      dispatch(setReCertification(updatedState));

      return updatedState;
    });
  };

  return (
    <Grid container spacing={3}>
      {/* Re-Certification */}
      <Grid item xs={12} className="d-flex flex-wrap align-items-center">
        <Grid item xs={12} sm={5}>
          <p className="mb-0">Re-Certification</p>
        </Grid>
        <Grid item xs={12} sm={7} className="d-flex flex-wrap">
          <Grid item xs={12} sm={4}>
            <TextField
              label="On-Site"
              size="small"
              value={ReCer.re_Certification[0].manDay.onSite}
              onChange={(e) =>
                handleChange("onSite", e.target.value, "re_Certification")
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              size="small"
              label="Off-Site"
              value={ReCer.re_Certification[0].manDay.offSite}
              onChange={(e) =>
                handleChange("offSite", e.target.value, "re_Certification")
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Fee"
              size="small"
              value={ReCer.re_Certification[0].manDay.fee}
              onChange={(e) =>
                handleChange("fee", e.target.value, "re_Certification")
              }
              fullWidth
            />
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <TextField
              label="Total Man Days"
              size="small"
              value={ReCer.re_Certification[0].manDay.totalManDays}
              fullWidth
              disabled
            />
          </Grid> */}
        </Grid>
      </Grid>

      {/* Surveillance Audits */}
      {ReCer.surveillanceAudit.map((audit) => (
        <React.Fragment key={audit.surveillanceAuditNumber}>
          {audit.surveillanceAuditNumber > 1 && (
            <>
              <Grid
                item
                xs={12}
                className="d-flex flex-wrap align-items-center"
              >
                <Grid item xs={12} sm={5}>
                  <p className="mb-0">
                    {`Surveillance Audit ${audit.surveillanceAuditNumber - 1}`}
                  </p>
                </Grid>
                <Grid item xs={12} sm={7} className="d-flex flex-wrap">
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="On-Site"
                      size="small"
                      value={audit.manDay.onSite}
                      onChange={(e) =>
                        handleChange(
                          "onSite",
                          e.target.value,
                          "surveillanceAudit",
                          audit.surveillanceAuditNumber
                        )
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      label="Off-Site"
                      value={audit.manDay.offSite}
                      onChange={(e) =>
                        handleChange(
                          "offSite",
                          e.target.value,
                          "surveillanceAudit",
                          audit.surveillanceAuditNumber
                        )
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      size="small"
                      label="Fee Year"
                      value={audit.manDay.fee}
                      onChange={(e) =>
                        handleChange(
                          "fee",
                          e.target.value,
                          "surveillanceAudit",
                          audit.surveillanceAuditNumber
                        )
                      }
                      fullWidth
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={4}>
                    <TextField
                      label="Total Man Days"
                      size="small"
                      value={audit.manDay.totalManDays}
                      fullWidth
                      disabled
                    />
                  </Grid> */}
                </Grid>
              </Grid>
            </>
          )}
        </React.Fragment>
      ))}
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          label="Administration Fee"
          value={ReCer.administrationFee}
          onChange={(e) =>
            handleChange(
              "administrationFee",
              e.target.value,
              "administrationFee"
            )
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          size="small"
          label="Total Contract Fee"
          value={ReCer.totalContractFee}
          onChange={(e) =>
            handleChange("totalContractFee", e.target.value, "totalContractFee")
          }
          fullWidth
          disabled
        />
      </Grid>
    </Grid>
  );
};

export default RAForm;
